import { MarketFactsAndFiguresContainer } from "./MarketFactsAndFiguresContainer/MarketFactsAndFiguresContainer";
import styles from "./MarketOverviewByInnovera.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography";
import { SectionContentWrapper } from "@/frontend/widgets/SectionContentWrapper/SectionContentWrapper";
import clsx from "clsx";
import { InnoveraBlockNoData } from "@/frontend/features/Company/ui/InnoveraBlockNoData/InnoveraBlockNoData";
import { SectionLoader } from "../../Section/SectionLoader/SectionLoader";
import { EDataStatus, TMarketReportData } from "@/frontend/features/Company/model/types/types";
import { calculateLoadingProgress } from "@/frontend/shared/lib/calculateLoadingProgress/calculateLoadingProgress";
import { TParsingStatus } from "@/libs/models/portfolio-companies";

export type TMarketOverviewByInnoveraProps = {
  onReportError?: () => void;
  marketOverviewData?: TMarketReportData;
  isLoadingMarketOverviewData?: boolean;
  marketOverviewDataStatus?: EDataStatus | TParsingStatus | null;
};

export function MarketOverviewByInnovera({
  onReportError,
  marketOverviewData: data,
  isLoadingMarketOverviewData: isLoading,
  marketOverviewDataStatus
}: TMarketOverviewByInnoveraProps) {
  const marketFactsAndFiguresContent = (
    <MarketFactsAndFiguresContainer data={data?.market?.keyFigures} className={styles.cardsContainer} />
  );

  const overviewContent = (
    <Typography variant="body-2" color="greyscale900" className={styles.description}>
      {data?.market?.overview}
    </Typography>
  );

  const progressPct = calculateLoadingProgress(marketOverviewDataStatus, data?.createdAt);
  const isProgressBarVisible =
    marketOverviewDataStatus !== "done" && marketOverviewDataStatus !== "error" && progressPct <= 100;

  const keyFiguresExists = !!data?.market?.keyFigures && data?.market?.keyFigures.length > 0;
  const overviewExists = !!data?.market?.overview;
  const content =
    keyFiguresExists || overviewExists ? (
      <div className={styles.innoveraBlock}>
        <div
          className={clsx(styles.innoveraBlockContentContainer, keyFiguresExists && overviewExists && styles.divider)}
        >
          {overviewContent}
        </div>
        {keyFiguresExists && (
          <div className={styles.innoveraSubBlockTitle} aria-level={7} role="heading">
            <Typography variant="heading-7" color="greyscale900">
              Market Facts and Figures
            </Typography>
          </div>
        )}
        {marketFactsAndFiguresContent}
      </div>
    ) : isLoading ? (
      <SectionLoader />
    ) : (
      <InnoveraBlockNoData />
    );

  return (
    <SectionContentWrapper
      isByInnovera
      viewSourceHref={data?.source}
      onReportError={onReportError}
      progress={{ visible: isProgressBarVisible, pct: progressPct }}
    >
      {content}
    </SectionContentWrapper>
  );
}
